<ng-container *transloco="let t; prefix:'tasks.taskList'">

  <mat-chip-listbox class="chip-list chip-filters" hideSingleSelectionIndicator="true">
    @for (chip of statusChips; track chip.status) {
      <mat-chip-option
        class="chip-item"
        (selectionChange)="onChipSelectedChange($event, chip.status)"
        [selected]="filters.statusType === chip.status">
        <div class="chip-option">
          <div class="chip-icon">
            <i [class]="chip.iconClass"></i>
          </div>
          <div class="chip-label">
            <div class="chip-label-primary title-small">
              {{ t(chip.labelKey) }}
              @if (!isMobile) {
                <span class="button-badge title-small">{{ getChipCount(chip.countProp) }}</span>
              }
            </div>
            <div class="chip-label-secondary">
              @if (isMobile) {
                <span class="button-badge title-small">{{ getChipCount(chip.countProp) }}</span>
              }
            </div>
          </div>
        </div>
      </mat-chip-option>
    }
  </mat-chip-listbox>

  <form [formGroup]="filtersForm" class="form">
    <mat-form-field appearance="outline" class="searchbar">
      <i matPrefix class="fa-regular fa-magnifying-glass icon-prefix"></i>
      <input matInput [placeholder]="t('searchTask')" formControlName="testo">
    </mat-form-field>

    @if (!isMobile) {
      <button
        matButton
        type="button"
        class="filter-trigger-button"
        [attr.aria-label]="'tasks.ui.mostraONascondiFiltri' | transloco"
        (click)="onFilterButtonClick()">
        <i class="fa-regular fa-filter"></i>
        <span class="label-large">{{ 'tasks.ui.filtri' | transloco }}</span>
      </button>
    }

    @if (!isMobile && filtersOpen) {
      <mat-card class="filters-card">
        <mat-card-content class="filters-card-content">

          <div class="filter-section">
            <span class="title-small filter-section-label">{{ 'tasks.ui.tipoTask' | transloco }}</span>
            <mat-chip-listbox multiple hideSingleSelectionIndicator="true">
              @for (tipo of tipiTask; track tipo) {
                <mat-chip-option
                  (selectionChange)="onInlineTipoTaskSelect($event, tipo)"
                  [selected]="checkInlineTipoTaskSelected(tipo)">
                  {{ tipo }}
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>

          <div class="filter-section">
            <span class="title-small filter-section-label">{{ 'tasks.ui.intervallo' | transloco }}</span>
            <div class="filter-date-fields">
              <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                <mat-label>{{ 'tasks.ui.dataInizio' | transloco }}</mat-label>
                <input matInput [matDatepicker]="pickerInizio" formControlName="dataInizio" [placeholder]="'tasks.ui.datePlaceholder' | transloco">
                <mat-datepicker-toggle matIconSuffix [for]="pickerInizio"></mat-datepicker-toggle>
                <mat-datepicker #pickerInizio></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                <mat-label>{{ 'tasks.ui.dataFine' | transloco }}</mat-label>
                <input matInput [matDatepicker]="pickerFine" formControlName="dataFine" [placeholder]="'tasks.ui.datePlaceholder' | transloco">
                <mat-datepicker-toggle matIconSuffix [for]="pickerFine"></mat-datepicker-toggle>
                <mat-datepicker #pickerFine></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="filter-section">
            <span class="title-small filter-section-label">{{ 'tasks.ui.priorita' | transloco }}</span>
            <div class="desktop-priority-options" role="group" [attr.aria-label]="'tasks.ui.priorita' | transloco">
              @for (priority of priorities; track priority) {
                <button
                  type="button"
                  class="desktop-priority-option"
                  [class.desktop-priority-option-selected]="checkInlinePrioritySelected(priority)"
                  [attr.aria-pressed]="checkInlinePrioritySelected(priority)"
                  (click)="toggleInlinePriority(priority)">
                  <ui-priority-status [priority]="priority"></ui-priority-status>
                </button>
              }
            </div>
          </div>

        </mat-card-content>
        <mat-card-actions align="end">
          <button matButton type="button" (click)="resetFilters()">{{ 'tasks.ui.azzeraFiltri' | transloco }}</button>
          <button matButton="filled" type="button" (click)="applyFilters()">{{ 'tasks.ui.applicaFiltri' | transloco }}</button>
        </mat-card-actions>
      </mat-card>
    }
  </form>

  <div class="mobile-task-list">
    @for (item of tasksArray; track item.id) {
      <button
        type="button"
        class="mobile-task-row"
        [attr.aria-label]="(('tasks.ui.apriDettaglioTask' | transloco) + ' ') + item.titolo"
        (click)="goToDetail(item)">
        <div class="mobile-task-row-content">
          <span class="mobile-task-title body-medium-emphasized">
            {{ item.titolo || '-' }}
          </span>

          <span class="mobile-task-metadata body-small">
            {{ item.nome || '-' }} - {{ item.primaryRole?.name || '-' }} - {{ (item.dataTask | date: 'dd/MM/yyyy HH:mm') || '-' }}
          </span>

          <span class="mobile-task-description body-small">
            {{ item.descrizione || '-' }}
          </span>

          <div class="mobile-task-footer">
            <ui-priority-status [priority]="item.priorita"></ui-priority-status>
            <span class="mobile-task-amount body-large-emphasized">
              {{ item.importo | translocoCurrency: 'symbol' : {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              } : 'EUR' }}
            </span>
          </div>
        </div>
        <span class="mobile-task-chevron" aria-hidden="true">
          <i class="fa-regular fa-chevron-right"></i>
        </span>
      </button>
    }

    <div #loadMoreTrigger class="load-more-trigger" aria-hidden="true"></div>
  </div>

  <div class="view-bar desktop-task-view">
    <mat-button-toggle-group
      [value]="selectedView"
      (change)="onViewChange($event.value)"
      class="toggle"
      hideSingleSelectionIndicator="true">
      @for (options of viewOptions; track options.value) {
        <mat-button-toggle [value]="options.value">
          <i [class]="options.iconClass"></i> {{ options.label }}
        </mat-button-toggle>
      }
    </mat-button-toggle-group>

  </div>

  @switch (selectedView) {
    @case ('table') {
      <ui-table-view
        class="table-view desktop-task-view"
        [data]="tasksArray"
        [columnsInfo]="columnsInfo"
        (sortChange)="onSortChange($event)"
        (rowClicked)="goToDetail($event)"
        (reloadData)="loadTasks()">
      </ui-table-view>
    }
    @case ('card') {
      <div class="card-list desktop-task-view">
        @for (item of tasksArray; track item.id) {
          <mat-card class="task-card" appearance="outlined" (click)="goToDetail(item)">
            <mat-card-content>
              <div class="task-card-header">
                <ui-priority-status [priority]="item.priorita"></ui-priority-status>
                <div class="task-card-main">
                  <span class="body-small">{{(item.dataTask | date: 'dd/MM/yyyy HH:mm') || '-'}}</span>
                  <span class="body-medium-emphasized">
                    @for (role of item.roles; track $index) {
                      {{role.name}}{{ $last ? '' : ', ' }}
                    } @empty {
                      -
                    }
                  </span>
                </div>
              </div>

              <mat-divider></mat-divider>

              <div class="task-card-details">
                <span class="label-medium-emphasized">{{item.importo | translocoCurrency: 'symbol' : currencyOptions : 'EUR'}}</span>
                <span class="task-card-name body-medium">{{item.nome}}</span>
                <span class="body-medium">{{item.titolo}}</span>
              </div>

              <span class="task-card-description body-medium">{{item.descrizione}}</span>
            </mat-card-content>
          </mat-card>
        }
      </div>
    }
  }

  <mat-paginator
    class="paginator desktop-task-view"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true"
    (page)="onPageChange($event)">
  </mat-paginator>

</ng-container>
